<template>
    <component
        :is="itemComponent"
        v-if="item.access"
        v-bind="itemProps"
        class="core-menu-list-item"
        @click="handleCLick"
    >
        <component :is="item.icon" class="menu-icon" size="18" />
        <span>{{ item.name }}</span>
    </component>
</template>

<script lang="ts">
    import { Component, Emit, Prop, Mixins } from 'vue-property-decorator';
    import { TopNavItemInterface } from '@/common/interfaces';
    import { CoreThemeMixin } from '@/common/mixins';
    import CoreShapedImage from '@/common/components/icon/CoreShapedImage.vue';
    import { Location } from 'vue-router';

    @Component({
        components: {
            CoreShapedImage,
        },
    })
    export default class CoreMenuItem extends Mixins(CoreThemeMixin) {
        @Prop({ default: {} }) public item!: TopNavItemInterface;

        public get itemComponent() {
            if (this.item.route === null) return 'span';

            return this.item.vueRoute ? 'router-link' : 'a';
        }

        public get itemProps(): { href: string } | { to: Location } | {} {
            if (this.item.route === null) {
                return {};
            }

            if (this.item.vueRoute) {
                if (typeof this.item.route === 'string') {
                    const location: Location = { path: this.item.route.replace('/app/', '/') };
                    return { to: location };
                }

                if (this.item.route.name) {
                    const location: Location = { name: this.item.route.name };
                    return { to: location };
                }

                return { to: '' };
            } else {
                return { href: this.item.route as string };
            }
        }

        @Emit('click')
        public handleCLick() {
            return undefined;
        }
    }
</script>
<style lang="less" scoped>
    .core-menu-list-item {
        .paragraph-dark();

        display: flex;
        align-items: center;
        width: 100%;
        min-width: 240px;
        height: 49px;
        margin: 0;
        padding-left: @spacing-16;
        font-size: 16px;
        border-radius: @border-radius-8;

        &:hover,
        &-active,
        &-selected {
            color: @primary-color;
            background-color: @primary-color-8;
            transition: @generic-transition;
        }
    }
    .menu-icon {
        margin-right: @spacing-18;
    }
</style>
